import { useContext } from 'react';
import { AuthContext, type AuthContextValue, type AuthUser } from './AuthContext';

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export function useCurrentUser(): AuthUser | null {
  return useAuth().user;
}
